// Manager Lab shell — step navigation Analyze → Scout → Select → Play → Review.
import React, { useCallback, useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { MagnifyingGlass, Binoculars, Scales, PlayCircle, ArrowCounterClockwise } from "@phosphor-icons/react";
import AppShell from "../../components/AppShell";
import { labSummary } from "../../lib/lab-api";

const STEPS = [
    { key: "analyze", label: "Analyze", icon: MagnifyingGlass },
    { key: "scout", label: "Scout", icon: Binoculars },
    { key: "select", label: "Select", icon: Scales },
    { key: "play", label: "Play", icon: PlayCircle },
    { key: "review", label: "Review", icon: ArrowCounterClockwise },
];

export default function LabLayout() {
    const [summary, setSummary] = useState(null);
    const refresh = useCallback(() => {
        labSummary().then(setSummary).catch(() => setSummary(null));
    }, []);
    useEffect(() => { refresh(); }, [refresh]);

    const badge = (key) => {
        if (!summary?.authenticated) return null;
        if (key === "scout" && summary.pool_total > 0) return summary.pool_total;
        if (key === "select" && summary.shortlist_count > 0) return summary.shortlist_count;
        if (key === "analyze" && summary.focuses_active > 0) return summary.focuses_active;
        return null;
    };

    return (
        <AppShell>
            <div data-testid="lab-page" className="space-y-6">
                <header className="flex flex-wrap items-end justify-between gap-3">
                    <div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-fa-mint">Manager Lab</div>
                        <h1 className="font-display font-black uppercase tracking-tight text-2xl md:text-3xl mt-1">
                            Rozhodovací systém
                        </h1>
                    </div>
                    {summary?.latest_focus && (
                        <div className="font-mono text-[10px] text-white/60 border border-fa-mint/30 bg-fa-mint/5 px-3 py-2" data-testid="lab-active-focus">
                            <span className="text-fa-mint uppercase tracking-widest">Aktivní focus:</span>{" "}
                            {summary.latest_focus.title} · GW{summary.latest_focus.gw_start}–{summary.latest_focus.gw_end}
                        </div>
                    )}
                </header>

                <nav className="flex flex-wrap gap-1 border border-white/10 bg-[#0d0d0d] p-2" data-testid="lab-step-nav">
                    {STEPS.map((s, i) => (
                        <NavLink key={s.key} to={`/lab/${s.key}`} data-testid={`lab-step-${s.key}`}
                                 className={({ isActive }) =>
                                     `font-mono text-[11px] uppercase tracking-widest px-3 py-2 flex items-center gap-1.5 transition-colors ${isActive ? "bg-fa-mint text-black font-bold" : "text-white/65 hover:text-white"}`}>
                            <span className="opacity-50">{i + 1}</span>
                            <s.icon size={12} />
                            {s.label}
                            {badge(s.key) != null && (
                                <span className="ml-1 font-mono text-[9px] tabular-nums px-1.5 py-0.5 bg-black/20">{badge(s.key)}</span>
                            )}
                        </NavLink>
                    ))}
                </nav>

                <Outlet context={{ summary, refresh }} />
            </div>
        </AppShell>
    );
}
